import { Popup } from './popup';

const popupCalls = { 
    init() {

        const menu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
        menu.init();

        const account = new Popup('#jsAccountWrap', '#jsOpenAccount', '#jsCloseAccount');
        account.init();

        const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
        cart.init();

        const search = new Popup('#jsSearchWrap', '#jsOpenSearch', '#jsCloseSearch');
        search.init();

        const help = new Popup('#jsHelpWrap', '#jsOpenHelp', '#jsCloseHelp');
        help.init();

        const gov = new Popup('#jsGovWrap', '#jsOpenGov', '#jsCloseGov');
        gov.init();

        const catList = new Popup('#jsCatsWrap', '.jsOpenCats', '#jsCloseCats');
        catList.init();

        const filters = new Popup('#jsFiltersWrap', '#jsOpenFilter', '#jsCloseFilters');
        filters.init();

        const gallery = new Popup('#jsGalleryWrap', '#jsOpenGallery', '#jsGalleryClose'); 
        gallery.init();

        window.addEventListener('reset', () => {
        const gallery = new Popup('#jsGalleryWrap', '#jsOpenGallery', '#jsGalleryClose'); 
        gallery.init();
        })
      
    },


};

export default popupCalls;
